module.exports = __webpack_public_path__ + "static/media/gps.9299c018.svg";